// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .container {
  width: 700px;
  height: 500px;
}`, "",{"version":3,"sources":["webpack://./src/app/editor/card-config/card-config.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/editor/card-config/card-config.component.scss"],"names":[],"mappings":"AACI;EACI,YAAA;EACA,aAAA;ACAR","sourcesContent":[":host {\n    .container {\n        width: 700px;\n        height: 500px;\n    }\n}",":host .container {\n  width: 700px;\n  height: 500px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
